// Dependencies
import { FC } from "react";
import { useSnackbar } from "notistack";
import { useMutation, useQueryClient } from "react-query";

// Components
import TransactionForm from "../TransactionForm";
import { addTransaction } from "~/services/transaction";
import { StyledAddLabel } from "~/components/Layout/LayoutAdd";
import { StyledInfoWrapper } from "~/components/Layout/LayoutInfo";

// Types
import { QUERY_KEY } from "~/enums";
import { TTransactionAddData, TQueryError } from "~/types";

interface TransactionAddProps {
  walletId: string;
  onCancel: Function;
}

const TransactionAdd: FC<TransactionAddProps> = ({ walletId, onCancel }) => {
  const { enqueueSnackbar } = useSnackbar();

  const queryClient = useQueryClient();

  // mutations
  const addTransactionMutation = useMutation({
    mutationFn: addTransaction,
    onSuccess() {
      enqueueSnackbar("Add Transaction success!", { variant: "success" });
      queryClient.invalidateQueries(QUERY_KEY.TRANSACTION.TRANSACTION_LIST);
      onCancel();
    },
    onError(error: TQueryError) {
      enqueueSnackbar(error.message, { variant: "error" });
    },
  });

  const handleAddTransaction = (data: TTransactionAddData) => {
    addTransactionMutation.mutate(data);
  };

  return (
    <StyledInfoWrapper>
      <StyledAddLabel key={1}>Add Transaction</StyledAddLabel>
      <TransactionForm
        key={2}
        walletId={walletId}
        onSubmit={handleAddTransaction}
        onCancel={onCancel}
      />
    </StyledInfoWrapper>
  );
};

export default TransactionAdd;
